var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing",on:{"scroll":function($event){return _vm.headerReact()}}},[_c('div',{staticClass:"mt-5 pt-5"},[_c('products')],1),_c('testimonials'),_c('modalTranslate',{on:{"changeLanguage":_vm.changeLanguage}}),_c('modalPopup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }